import {
  Notification,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

/**
 * Creates a handler for Notification WebSocket messages
 *
 * @param eventEmitter - Event emitter to dispatch events to subscribers
 * @returns Handler function for Notification messages
 */
export function createNotificationMessageHandler(eventEmitter: IEventEmitter) {
  return (action: WebSocketAction, item: Notification) => {
    try {
      switch (action) {
        case WebSocketAction.INSERT:
          log.debug(`[NotificationHandler] INSERT Notification ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.Notification,
            WebSocketEventType.INSERT,
            item,
          );
          break;
        case WebSocketAction.MODIFY:
          log.debug(`[NotificationHandler] MODIFY Notification ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.Notification,
            WebSocketEventType.MODIFY,
            item,
          );
          break;
        case WebSocketAction.REMOVE:
          log.debug(`[NotificationHandler] REMOVE Notification ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.Notification,
            WebSocketEventType.REMOVE,
            item,
          );
          break;
        default:
          log.warn(
            '[NotificationHandler] Unknown action for Notification:',
            action,
          );
      }
    } catch (error) {
      log.error('[NotificationHandler] Handler failed:', error);
    }
  };
}
